import store from "../../../store"
import { axiosWrapper } from "../../axios_old"
import { Data } from "../../formating"
import preparePayload from "../preparePayload"

const provider = async (args) => {
	const { user, data, action, setNotification } = args
	try {
		let newData = {}

		if (action === "GET_ALL") {
			const providers = new Map()
			const { data: providersAPI } = await axiosWrapper("GET", "provider", null, null, user.token)

			providersAPI.forEach((prov) => providers.set(prov.id, Data.Provider({ provider: prov })))
			return providers
		} else if (action === "GET_ONE") {
			const { data: providersAPI } = await axiosWrapper("GET", "provider", null, null, user.token)

			const provider = providersAPI.find((prov) => prov.id === data.id)

			return Data.Provider({ provider })
		} else if (action === "CREATE") {
			newData = await preparePayload({
				user,
				schema: "provider",
				data,
				url: "provider"
			})
			newData = { ...newData, id: newData.providerId }
			if (setNotification) {
				await store.setNotification("notification", true, {
					msg: `Successfully added ${data.name}.`,
					severity: "success",
					isPersist: true
				})
			}
		} else if (action === "UPDATE") {
			newData = await preparePayload({
				user,
				schema: "provider",
				data,
				url: `provider/${data.id}`
			})
			await store.setNotification("notification", true, {
				msg: `Successfully updated provider ${data.name}.`,
				severity: "success",
				isPersist: true
			})
		} else if (action === "DELETE") {
			await axiosWrapper(`DELETE`, `provider/${data.id}`, null, null, user.token)
			await store.setNotification("notification", true, {
				msg: `Successfully removed provider ${data.name}.`,
				severity: "success"
			})
		}

		return newData
	} catch (err) {
		if (setNotification) {
			await setNotification("notification", true, {
				msg: err?.response?.data?.message,
				severity: "error"
			})
		}
		console.error(err)
	}
}

export default provider
